/**
 * Questo file definisce la pagina Dashboard.
 * - È la pagina principale per gli utenti autenticati.
 * - Dà il benvenuto all'utente con il suo nome.
 * - Presenta una serie di "action card", ovvero dei collegamenti visivi
 * alle sezioni principali dell'area utente:
 * 1. "Crea nuove flashcard": porta alla pagina di generazione.
 * 2. "Le mie flashcard": porta alla pagina di gestione delle proprie cartelle.
 * - Mostra una card aggiuntiva, "Pannello Amministratore", solo se l'utente
 * ha il ruolo di 'admin'.
 * - Include il componente `WeatherWidget` per mostrare le informazioni meteo.
 * - Ottiene i dati dell'utente (nome, ruolo) dallo store Redux per personalizzare la vista.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import WeatherWidget from '../components/WeatherWidget';
import './Dashboard.css';

export default function Dashboard() {
    // Estrae i dati dell'utente loggato dallo store Redux.
    const { user } = useSelector((state) => state.auth);
    // Controlla se l'utente è un amministratore.
    const isAdmin = user?.ruolo === 'admin';

    return (
        <>
            <Navbar />
            <div className="dashboard-container">
                <div className="container">
                    {/* Intestazione della dashboard */}
                    <div className="dashboard-header">
                        {/* Saluto personalizzato con il nome dell'utente. */}
                        <h1 className="display-5 fw-bold">Bentornato, {user?.nome || 'utente'}!</h1>
                        <p className="lead text-muted">Cosa vuoi fare oggi?</p>
                    </div>

                    {/* Widget Meteo */}
                    <WeatherWidget />

                    {/* Contenuto principale con le card di azione */}
                    <div className="dashboard-content">
                        <div className="row g-4">
                            {/* Card per la creazione di flashcard */}
                            <div className="col-lg-6">
                                <Link to="/create" className="action-card create-card h-100">
                                    <div className="action-card-body">
                                        <div className="action-icon">
                                            <i className="bi bi-plus-circle-fill"></i>
                                        </div>
                                        <h4 className="action-title">Crea nuove flashcard</h4>
                                        <p className="action-text">Carica un documento e trasformalo in un set di studio intelligente.</p>
                                    </div>
                                </Link>
                            </div>

                            {/* Card per visualizzare le proprie flashcard */}
                            <div className="col-lg-6">
                                <Link to="/my-flashcards" className="action-card view-card h-100">
                                    <div className="action-card-body">
                                        <div className="action-icon">
                                            <i className="bi bi-collection-fill"></i>
                                        </div>
                                        <h4 className="action-title">Le mie flashcard</h4>
                                        <p className="action-text">Sfoglia, modifica e studia le tue cartelle e le tue flashcard.</p>
                                    </div>
                                </Link>
                            </div>

                            {/* Card per il pannello admin, mostrata condizionalmente */}
                            {isAdmin && (
                                <div className="col-lg-12">
                                    <Link to="/admin" className="action-card admin-card h-100">
                                        <div className="action-card-body">
                                            <div className="action-icon">
                                                <i className="bi bi-shield-lock-fill"></i>
                                            </div>
                                            <h4 className="action-title">Pannello Amministratore</h4>
                                            <p className="action-text">Gestisci le cartelle pubbliche e approva i contenuti per la community.</p>
                                        </div>
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}